<template>
  <div>
    <div class="header text-center">
      <h1 class="text-white">
        {{ title }}
      </h1>
    </div>
    <div
      v-if="subTitle"
      class="header__subtitle align-center"
    >
      <h2>{{ subTitle }}</h2>
    </div>
    <Breadcrumb v-if="back" class="toLeft"/>
  </div>
</template>
<script>
import Breadcrumb from "@/components/ComponentBreadcrumb";

export default {
  name: "PageHeader",
  components: {
    Breadcrumb
  },
  props: {
    back: {
      type: Boolean,
      required: false,
      default: false
    },
    title: {
      type: String,
      required: true
    },
    subTitle: {
      type: String,
      required: false,
      default: ""
    }
  }
};
</script>
<style scoped>
h1 {
  padding-top: 44px;
  font-size: 48px;
  line-height: 1.5;
  position: relative;
  color: #fff;
}

h2 {
  font-weight: 200;
  color: #4a4a4a;
}

.header {
  background-image: url(../isaluAssets/img/png/bg-seller-login.png);
  background-position: center center;
  background-size: cover;
  height: 180px;
  position: relative;
}

.header__subtitle {
  background-color: rgba(248, 248, 248, 1);
  height: 70px;
  display: flex;
}

.header__subtitle h2 {
  margin: 0;
  padding: 0;
}

.header:before {
  position: absolute;
  content: "";
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
}

.toLeft {
  align-items: flex-start;
}

@media (max-width: 720px) and (min-width: 240px) {
  h1 {
    padding-top: 70px;
    font-size: 40px;
  }
}
</style>
